<template>
  <b-container fluid>
    <b-card title="Elementenbeheer">
      <b-alert
        v-if="!($store.state.user.roles || '').split(',').includes('Beheerder')"
        show
      >
        Geen beheerder toegang!
      </b-alert>
      <b-row v-else>
        <b-col
          v-for="(element, index) in elementen"
          v-show="element.Form.group"
          :key="index"
          md="6"
        >
          <element-edit-card
            :title="element.Naam"
            :form="element.Form"
            :data="inventarisatie"
            :code="element.Code"
          >
            <b-badge class="pull-right">
              {{ element.Code }}
            </b-badge>
          </element-edit-card>
        </b-col>
      </b-row>
    </b-card>
  </b-container>
</template>

<script>
import ElementEditCard from "@/components/ElementEditCard";
import { elementenMixin } from "@/mixins/elementenMixin";


export default {
  components: {
    ElementEditCard,
  },
  mixins: [elementenMixin],
  data() {
    return {
      elementen: [],
    };
  },
  mounted() {
    this.loadElementen();
  },
};
</script>